import template from './component.tpl.html';
import ComponentsSelectizeController from './controller';

/**
 * @ngdoc component
 * @name components.component:al-switch
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="components">
 <file name="index.html">
 <al-switch config="{}" model="" on-change="vm.changedSlider(newVal)"></al-switch>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.components')
    .component('alSwitch', {
        bindings: {
            model: '=',
            config: '<',
            onChange: '&'
        },
        controller: ComponentsSelectizeController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/al-switch/component.js